import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsRoutingModule } from './news-routing.module';
import { NewsComponent } from './news.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NewsGQL } from '@shared/services/news/news.gql.service';
import { PagedVirtualScrollerModule } from '@shared/components/paged-virtual-scroller/paged-virtual-scroller.module';


import { NewsBlockModule } from '@news/views/news-block/news-block.module';
import { SoftDeleteNewsGQL } from '@shared/services/news/news-soft-delete.gql.service';


@NgModule({
    imports: [
    CommonModule,
    NewsRoutingModule,
    PagedVirtualScrollerModule,
    MatButtonModule,
    MatIconModule,
    NewsBlockModule,
    NewsComponent
],
    providers: [
        NewsGQL,
        SoftDeleteNewsGQL
    ]
})
export class NewsModule { }
